/** Switch controlling whether Microsoft/service-principal activity is shown.
 *
 *  The audit trail is dominated by machine-generated records (Microsoft
 *  Substrate Management, background service principals, system policies) that
 *  bury the human actions an auditor is looking for. These are hidden by
 *  default and opted back in here.
 */
import React from "react";
import Toggle from "./Toggle";

interface ShowSystemToggleProps {
  show: boolean;
  onChange: (show: boolean) => void;
}

export default function ShowSystemToggle({ show, onChange }: ShowSystemToggleProps) {
  return (
    <Toggle
      checked={show}
      onChange={onChange}
      label="Show system actions"
      title={
        "Microsoft and service-principal activity (e.g. Microsoft Substrate Management) " +
        "is hidden by default so the trail shows human actions"
      }
    />
  );
}
